import React from 'react';
import ReactDOM from 'react-dom';
import Entry from './Entry';

ReactDOM.render((
  <Entry />
), document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.js